module.exports = __webpack_public_path__ + "img/work_better6.853e3af9.png";